import { ThemeMenu } from './ThemeMenu';

/**
 * Topbar theme switcher · slot_theme_inkteal_indigo (29 JUN 2026).
 * Была cycle-кнопка (warm → mint → dark → …); на 5 тем заменена на поповер-пикер
 * (ThemeMenu, variant="topbar"). Класс триггера `.theme-btn` сохранён.
 */
export function ThemeSwitcher() {
  return <ThemeMenu variant="topbar" />;
}
